import {FetchMode, ItemSelectComponent} from './item-select.component';
import { Component, forwardRef, Input, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {map, shareReplay} from 'rxjs/operators';
import {LinkService} from '../../services/link.service';
import {LinkType} from '../../models/link';

@Component({
    selector: 'app-link-type-select',
    templateUrl: './item-select.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => LinkTypeSelectComponent),
            multi: true
        }
    ],
    standalone: false
})
export class LinkTypeSelectComponent extends ItemSelectComponent<LinkType, {}> {
    private linkService = inject<LinkService>('LinkService' as any);

    linkTypes = this.linkService.listLinkTypes().pipe(
        shareReplay(1)
    );

    constructor() {
        super(FetchMode.Full);
    }

    getLabelText(item: LinkType): string {
        return item.value;
    }

    loadMoreItems(filter: { term: string }): Observable<LinkType[]> {
        return this.linkTypes.pipe(
            map(items => items.filter(it => it.value.toLowerCase().includes((filter.term || '').toLowerCase()))),
        );
    }

    compare(a: LinkType, b: LinkType): boolean {
        if (!a || !b) {
            return false;
        }

        return a.key === b.key;
    }
}
